import styled, { css } from 'styled-components';
import Image from '@components/image';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      align-items: stretch;
    }
  `}
`;

export const LinkButton = styled.a`
  display: flex;
`;

export const StyledImage = styled(Image)`
  ${({ theme }) => css`
    width: auto;
    height: 3.5rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      height: 3rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      height: 2.5rem;
    }
  `}
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-weight: 500;

  ${({ theme }) => css`
    font-size: ${theme.fontSize.body.desktop};
  `}
`;

export const Label = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.fontSize.extraSmall.desktop};
  `}
`;
